import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "stats-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatItem = _resolveComponent("StatItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_StatItem, {
      value: _ctx.fileCountValue,
      unit: _ctx.fileCountUnit,
      title: ``,
      "stat-type": `stat-total`
    }, null, 8, ["value", "unit"]),
    _createVNode(_component_StatItem, {
      value: _ctx.sizeCountValue,
      unit: _ctx.sizeCountUnit,
      title: ``,
      "stat-type": `stat-total`
    }, null, 8, ["value", "unit"])
  ]))
}